import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
/* */
import InputLabel from '@atoms/InputLabel'; 



const useStyles = makeStyles((theme) => ({
  controlLabel: {
      marginLeft: '10%',
      marginRight: 0
  },
}));






/** 
 * @component SelectField 
 * 
 * @props id    - input id
 * @props label -input label
 * @props field - control input react-hook-form
 * @props withIcon - bolean
 * @props options  - option array{ value: "",label: "",icon: "icon-url"}
 * */ 
export default function RadioField(props) {
  const classes = useStyles();


  return (
    <Box>  
      <InputLabel>  { props.label }  </InputLabel>
      <RadioGroup aria-label="gender" name="gender1" {...props.field} style={{ display: 'block'}}>
      {/* loop option props */}
        {props.options.map((option , index) => (
           <FormControlLabel 
             value={option.value} 
             control={<Radio />} 
             label={option.label} 
             disabled={props.isSubmitted}
             style={{ marginLeft:'15%', marginRight: 0, marginTop: 5 }} 
             key={index}
            />
         ))}
      </RadioGroup>
      <p style={{color: 'red', margin: 0}}>{props.error && "هذا الحقل مطلوب *"}</p>
    </Box>
);
}